export default {"src":"/_next/static/image/public/images/ic_stethoscope.e9d361b75b831060b4a9489816b8f2bf.svg","height":32,"width":32};